export default {
  priv: 'pr_reference',
  overviewTitle: 'Servers',
  detailTitle: 'Server',
  deleteTitle: 'deze server',
  url: '/references/servers',
  apiUrl: '/servers/',
  sortBy: ['name'],
  sortDesc: [false],
  deletable: true,
  editable: true,
  filterName: 'addresses',
  quickFilter: {
    text: 'Zoek op naam, adres, serienr',
    value: 'misc'
  },
  tableFields: [
    {
      text: 'Naam',
      value: 'name',
      link: '/references/servers/{id}',
      width: '20%'
    },
    {
      text: 'Adres',
      value: 'cab',
      width: '35%'
    },
    {
      text: 'Server',
      value: 'fixed',
      align: 'center',
      width: '20%'
    }
  ]
};
